import { gql } from "@apollo/client"

export const MUTATION = gql`
  mutation RemoveNews($id: String!) {
    removeNews(id: $id)
  }
`
